import React, { PureComponent } from "react";
import { PropTypes } from "prop-types";
import { Container } from "semantic-ui-react";

import ProjectCIDRPanel from "./ProjectCIDRPanel.jsx";
import ProjectSSHPanel from "./ProjectSSHPanel.jsx";

// Designed to be used with the withBasicForm HOC

class ProjectSettingsForm extends PureComponent {
  static propTypes = {
    data: PropTypes.object.isRequired
  };

  static defaultProps = {
    copyKey: "project_settings"
  };

  // -- RENDER -- //

  render() {
    const { data } = this.props;

    return (
      <Container>
        {data.hasOwnProperty("cidrClassPrefix") && (
          <ProjectCIDRPanel
            id="cidrClassPrefix"
            cidrClassPrefix={data.cidrClassPrefix}
          />
        )}

        {data.hasOwnProperty("sshKeys") && (
          <ProjectSSHPanel id="sshKeys" data={data.sshKeys} />
        )}
      </Container>
    );
  }
}

export default ProjectSettingsForm;
